import { CSSProperties } from "react";

import { useTheme, useWindowDimensions } from "@hooks";
import { constants, spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();
  const { width } = useWindowDimensions();
  const isSmallScreen = width <= 1150;
  const isMobile = width <= 600;

  const styles: Record<string, CSSProperties> = {
    container: {
      marginLeft: spacing.m,
      marginRight: spacing.m,
      padding: spacing.xs,
      backgroundColor: theme.verification.banner.home.error,
      borderRadius: constants.radius.view,
      marginBottom: isMobile ? spacing.xs : spacing.m,
      width: isMobile ? 350 : undefined,
      maxWidth: isMobile ? 350 : undefined,
      justifySelf: isMobile ? "center" : undefined,
      boxSizing: "border-box",
      cursor: "pointer",
      userSelect: "none",
    },
    content: {
      display: "flex",
      flexDirection: isSmallScreen ? "column" : "row",
      alignItems: isSmallScreen ? "flex-start" : "center",
      gap: isSmallScreen ? spacing.xs : 0,
    },
    icon: {
      flexShrink: 0,
      width: 24,
      height: 24,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    logo: {
      width: 16,
      height: 16,
      objectFit: "contain",
    },
    title: {
      marginLeft: spacing.xs,
      fontWeight: 700,
    },
    subtitle: {
      marginLeft: spacing.xs,
    },
    linkHint: {
      marginLeft: spacing.xs,
      textDecoration: "underline",
      fontWeight: 700,
    },
  };

  return styles;
};
